import WhiteBox from '../common/WhiteBox';
import './AuthTemplate.scss';

const AuthTemplate = ({ children }) => {
  return (
    <div className="AuthTemplate">
      <WhiteBox>{children}</WhiteBox>
    </div>
  );
};

export default AuthTemplate;
